/* RESPONSIBLE TEAM: team-self-serve */
import type AppService from 'embercom/services/app-service';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class IntershopProductsProductController extends Controller {
  queryParams = ['showPermissionsModal', 'showSecondaryWorkspaceModal'];

  @service declare appService: AppService;
  @tracked showPermissionsModal = null;
  @tracked showSecondaryWorkspaceModal = null;

  get app(): any {
    return this.appService.app;
  }

  get isSecondaryWorkspaceModalOpen(): boolean {
    return this.showSecondaryWorkspaceModal !== null;
  }

  get isPermissionModalOpen(): boolean {
    return this.showPermissionsModal !== null;
  }

  @action
  onModalClose(): void {
    this.showSecondaryWorkspaceModal = null;
    this.showPermissionsModal = null;
  }
}
